import { useState } from 'react';
import { useSnackbar } from 'notistack';
import { getResponseMessage } from '../../../../utils/utils';
import { useFormatMessage } from '../../../../hooks';
import { getCDEKCities } from '../../../../crud/pickupPoints.crud';

export const useGetCities = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loadingCdekCities, setLoading] = useState(false);
  const fm = useFormatMessage();
  const [cdekCities, setCdekCities] = useState<any[]>([]);

  const fetchCities = async (name?: string) => {
    setLoading(true);
    getCDEKCities(name)
      .then((res: any) => {
        setCdekCities(res.data.data);
      })
      .catch(e => {
        enqueueSnackbar(`${fm('ERROR')}: ${getResponseMessage(e)}`, { variant: 'error' });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return {
    fetchCities,
    loadingCdekCities,
    cdekCities,
  };
};
